import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { AppSettings, enumStatusCodeList } from '../../../sharedcomponents/_common/constants/app.constants';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { UserService } from '../../../_services/userservice/user.service';
import { User } from 'app/models/user/user';
export class CustomModalContext extends BSModalContext {
  public editproofilemodalData: any;
  // isMobileUpdated:any;
}

@Component({
  selector: 'app-verify-device',
  templateUrl: './user-editProfileMobileOTPVerification.html',
  providers: [Modal, AlertService, UserService]
})
export class EditProfileMobileOTPComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  model: any = {};
  errorMessage;

  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    private modal: Modal,
    public utilserv: utilityService,
    private alertService: AlertService,
    public translate: TranslateService,
    private userService: UserService,
    private vcRef: ViewContainerRef
  ) {
    this.context = this.dialog.context;
    this.modalData = this.dialog.context.editproofilemodalData;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  ngOnInit() { }
  verifyOTP() {
    this.model.MethodName = 'SMS_EditProfile';
    this.model.MobileNumber = this.modalData.mobileNumber;
    this.model.txtOTP = this.model.otpNumber;
    this.model.mailOTP = this.model.mailotpNumber;
    this.model.UserID = this.modalData.UserID;
    this.modal.overlay.defaultViewContainer = this.vcRef;
    this.userService.verifyUserMobile(this.model).subscribe(data => {
      const resJSON = data;

      if (resJSON.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.userProfileUpdated) {
        this.dialog.context.editproofilemodalData.isMobileUpdated = 'yes';
        // this.dialog.context.isMobileUpdated.status = true;
        this.dialog.close();
        return true;
      } else {
        this.dialog.context.editproofilemodalData.isMobileUpdated = 'no';
        this.errorMessage = this.translate.instant('OTPConfirmPopup_failDesc');
        this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.errorMessage);
        return false;
      }
    });
  }
  closePopup() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/user-editprofile-mobileOTPVerification/user-editProfileMobileOTPVerification.ts